/* ============================================================
   FootyFits homepage — shared motion (robust / re-scannable).
   - Content is visible by default. Only when JS runs and motion is
     allowed do we add html.awb-motion (which hides .awb-fade until
     revealed) — so a missed scan can never leave content blank.
   - fade-in via one shared IntersectionObserver; re-observes new
     .awb-fade elements on every call and on shopify:section:load.
   - parallax on [data-parallax] via one shared rAF scroll loop that
     re-queries the DOM (so newly-added sections work too).
   - honours prefers-reduced-motion (no motion, everything visible).
   Safe to load from multiple sections (state lives on window).
   ============================================================ */
(function(){
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if(!reduce) document.documentElement.classList.add("awb-motion");

  function ensureIO(){
    if(window.__awbIO || reduce || !("IntersectionObserver" in window)) return window.__awbIO;
    window.__awbIO = new IntersectionObserver(function(entries){
      for(var i = 0; i < entries.length; i++){
        if(entries[i].isIntersecting){
          entries[i].target.classList.add("is-in");
          window.__awbIO.unobserve(entries[i].target);
        }
      }
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    return window.__awbIO;
  }

  function observeFades(){
    var io = ensureIO();
    var els = document.querySelectorAll(".awb-fade:not([data-awb-seen])");
    for(var i = 0; i < els.length; i++){
      els[i].setAttribute("data-awb-seen", "1");
      if(io) io.observe(els[i]); else els[i].classList.add("is-in");
    }
  }

  function updatePara(){
    window.__awbTick = false;
    if(reduce) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var items = document.querySelectorAll("[data-parallax]");
    for(var i = 0; i < items.length; i++){
      var el = items[i], r = el.parentNode.getBoundingClientRect();
      if(r.bottom < -60 || r.top > vh + 60) continue;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = "translate3d(0," + (p * 18).toFixed(1) + "px,0) scale(1.02)";
    }
  }
  function onScroll(){ if(!window.__awbTick){ window.__awbTick = true; requestAnimationFrame(updatePara); } }

  // Partner logo marquee: clone the set enough to always overflow, then loop seamlessly.
  function buildMarquee(m, track){
    if(!track.__awbSet){
      var kids = Array.prototype.slice.call(track.children);
      if(!kids.length) return;
      var w = 0;
      for(var i = 0; i < kids.length; i++){
        var cs = getComputedStyle(kids[i]);
        w += kids[i].getBoundingClientRect().width + parseFloat(cs.marginRight || 0) + parseFloat(cs.marginLeft || 0);
      }
      if(w <= 0) return;
      track.__awbSet = kids.map(function(el){ return el.cloneNode(true); });
      track.__awbSetW = w;
    }
    var setW = track.__awbSetW;
    var contW = m.getBoundingClientRect().width || window.innerWidth;
    var repeats = Math.max(1, Math.ceil(contW / setW) + 1); // one half comfortably wider than the screen
    track.innerHTML = "";
    for(var half = 0; half < 2; half++){
      for(var r = 0; r < repeats; r++){
        for(var k = 0; k < track.__awbSet.length; k++){ track.appendChild(track.__awbSet[k].cloneNode(true)); }
      }
    }
    var halfW = setW * repeats; // animation moves the track by exactly one half (-50%)
    var secs = parseFloat(getComputedStyle(track).getPropertyValue("--awb-marquee-speed")) || 35;
    var pxPerSec = 2000 / secs; // keep a constant speed regardless of how wide the track grew
    track.style.animation = "awb-marquee " + (halfW / pxPerSec).toFixed(1) + "s linear infinite";
    track.setAttribute("data-awb-mq", "1");
  }

  function fillMarquees(){
    if(reduce) return; // reduced motion keeps the static, wrapped fallback
    var marquees = document.querySelectorAll(".awb-marquee");
    for(var i = 0; i < marquees.length; i++){
      (function(m){
        var track = m.querySelector(".awb-marquee-track");
        if(!track || track.getAttribute("data-awb-mq")) return;
        var imgs = track.getElementsByTagName("img"), remaining = 0;
        for(var j = 0; j < imgs.length; j++){ if(!imgs[j].complete) remaining++; }
        var done = false;
        function go(){ if(done || !track.isConnected) return; done = true; buildMarquee(m, track); }
        if(remaining === 0){ go(); return; }
        for(var j = 0; j < imgs.length; j++){
          if(!imgs[j].complete){
            var h = function(){ if(--remaining <= 0) go(); };
            imgs[j].addEventListener("load", h); imgs[j].addEventListener("error", h);
          }
        }
        setTimeout(go, 2000); // never wait forever on a slow logo
      })(marquees[i]);
    }
  }

  function reflowMarquees(){
    if(reduce) return;
    var tracks = document.querySelectorAll(".awb-marquee-track[data-awb-mq]");
    for(var i = 0; i < tracks.length; i++){
      if(tracks[i].__awbSet) buildMarquee(tracks[i].closest(".awb-marquee"), tracks[i]);
    }
  }

  function init(){ observeFades(); updatePara(); fillMarquees(); }

  if(!window.__awbBound){
    window.__awbBound = true;
    if(!reduce){
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      var _mqT;
      window.addEventListener("resize", function(){ clearTimeout(_mqT); _mqT = setTimeout(reflowMarquees, 200); });
    }
    // Shopify theme editor: re-init when a section is added/reloaded
    document.addEventListener("shopify:section:load", init);
  }

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
